import { Link } from 'react-router-dom'
import '../assets/css/Common.css'
import '../assets/css/SmallArticlePreview.css'
import { formatDate } from '../services/CommonService'
import ZoomedImage from './ZoomedImage'
import { useMemo } from 'react'


function SmallArticlePreview({ articleId, title, category, date, image, url }) {
    const memoisedFormatDate = useMemo(() => formatDate(date), [formatDate])

    return (
        <div className="small-article-preview">
            <Link to={"/" + url} state={{ 
                    articleId,
                    title,
                    image,
                    date: memoisedFormatDate,
                    categoryName: category
            }}>
                <ZoomedImage cssClassNames={'float-left left-div-small'} 
                        image={image} 
                        imgCssClassNames={'central-right-img'}
                />
                <div className='float-right right-div-small space-between'>
                    <p className={category === 'Promo' ? 'category-name category-name--promo' : 'category-name text-white'}>
                        {category}
                    </p>
                    <p className="small-article-title text-white">{title}</p>
                    <p className='text-white small-article-date'>{memoisedFormatDate}</p>
                </div>
            </Link>
        </div>
    )
}

export default SmallArticlePreview